import { render, staticRenderFns } from "./OfflineApp.vue?vue&type=template&id=35c1171c&"
var script = {}
import style0 from "./OfflineApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports